export const MIN_CART_VALUE_FOR_FREE_DELIVERY = 10;

export const BASE_DELIVERY_FEE = 2;
export const BASE_DELIVERY_DISTANCE = 1000;
export const ADDITIONAL_DISTANCE_STEP = 500;
export const ADDITIONAL_DISTANCE_FEE = 1; 

export const EXTRA_ITEMS_THRESHOLD = 4;
export const EXTRA_ITEM_FEE = 0.5;

export const FREE_DELIVERY_CART_VALUE = 100;
export const MAX_DELIVERY_FEE = 15;

export const RUSH_HOURS: number[] = [15, 16, 17, 18]; 
export const RUSH_DAY: number = 5; 
export const RUSH_HOUR_MULTIPLIER = 1.1;

export const MIN_TIME = new Date("1975-04-30T00:00:00"); 
export const MAX_TIME = new Date("2500-01-01T00:00:00");

export const MunchiURLs = {
  mainpage : "https://www.gomunchi.com/",
  login : "https://dashboard.gomunchi.com/login"
}


